/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable jsx-a11y/img-redundant-alt */
// SliderComponent.js
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

const Slider2 = () => {
  const { t } = useTranslation();

  // Modern pagination styles
  const paginationStyles = `
    .swiper-pagination {
      bottom: 30px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      width: auto !important;
      text-align: center !important;
    }
    
    .swiper-pagination-bullet {
      width: 12px !important;
      height: 12px !important;
      background: rgba(255, 255, 255, 0.4) !important;
      border-radius: 50% !important;
      cursor: pointer !important;
      transition: all 0.3s ease !important;
      border: 2px solid transparent !important;
      opacity: 1 !important;
      margin: 0 6px !important;
    }
    
    .swiper-pagination-bullet:hover {
      background: rgba(255, 255, 255, 0.7) !important;
      transform: scale(1.1) !important;
    }
    
    .swiper-pagination-bullet-active {
      background: #ffffff !important;
      border: 2px solid #00bcd4 !important;
      transform: scale(1.2) !important;
      box-shadow: 0 0 10px rgba(0, 188, 212, 0.5) !important;
    }
  `;

  // Mobil/masaüstü arka plan görselleri için sınıf bazlı stiller
  const sliderBgStyles = `
    .hero-slider-one__bg { background-position: center; background-size: cover; }

    .bg-slide-1 { background-image: url(assets/images/slider/1.webp); }
    .bg-slide-2 { background-image: url(assets/images/slider/2.webp); }
    .bg-slide-3 { background-image: url(assets/images/slider/3.webp); }
    .bg-slide-4 { background-image: url(assets/images/slider/4.webp); }
    .bg-slide-5 { background-image: url(assets/images/slider/5.webp); }
    .bg-slide-6 { background-image: url(assets/images/slider/6.webp); }

    @media (max-width: 768px) {
      .bg-slide-1 { background-image: url(assets/images/slider/mobile/1.webp); }
      .bg-slide-2 { background-image: url(assets/images/slider/mobile/2.webp); }
      .bg-slide-3 { background-image: url(assets/images/slider/mobile/3.webp); }
      .bg-slide-4 { background-image: url(assets/images/slider/mobile/4.webp); }
      .bg-slide-5 { background-image: url(assets/images/slider/mobile/5.webp); }
      .bg-slide-6 { background-image: url(assets/images/slider/mobile/6.webp); }
    }
  `;

  // Mobil responsive düzenlemeler
  const sliderLayoutStyles = `
    .hero-slider-one { 
      overflow: hidden !important; 
    }
    .hero-slider-one__carousel { 
      overflow: hidden !important; 
      width: 100% !important;
    }
    /* Yatay taşmaları engelle */
    html, body {
      overflow-x: hidden !important;
      width: 100% !important;
    }
    .swiper, .swiper-wrapper {
      width: 100% !important;
    }

    /* Full-bleed: container/row/col padding/margin sıfırla */
    .hero-slider-one .container,
    .hero-slider-one .row,
    .hero-slider-one .col-xxl-12,
    .hero-slider-one .col-xl-10,
    .hero-slider-one .col-lg-10 {
      padding-left: 0 !important;
      padding-right: 0 !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      max-width: 100% !important;
      width: 100% !important;
    }
    .hero-slider-one__item {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    /* Desktop (>=992px) yükseklik optimizasyonu */
    @media (min-width: 992px) {
      .hero-main-slider { 
        height: 70vh !important; 
        min-height: 520px !important; 
        margin-bottom: 0 !important;
      }
      .hero-slider-one__item { 
        height: 70vh !important; 
        min-height: 520px !important; 
        padding-top: 100px !important; 
        padding-bottom: 40px !important; 
      }
    }

    @media (max-width: 768px) {
      .hero-main-slider { 
        height: 60vh !important; 
        min-height: 400px !important; 
        margin-bottom: 0 !important;
      }
      .hero-slider-one__item { 
        height: 60vh !important; 
        min-height: 400px !important; 
        padding-top: 80px !important; 
        padding-bottom: 30px !important; 
      }
      .hero-slider-one__title { 
        font-size: 32px !important; 
        line-height: 1.2 !important; 
      }
      .hero-slider-one__sub-title { 
        font-size: 16px !important; 
      }
      .about-one.section-space-top,
      .about-one.mt-5,
      .section-space-top {
        margin-top: 0 !important;
        padding-top: 0 !important;
      }
    }

    @media (max-width: 576px) {
      .hero-main-slider { 
        height: 50vh !important; 
        min-height: 350px !important; 
        margin-bottom: 0 !important;
      }
      .hero-slider-one__item { 
        height: 50vh !important; 
        min-height: 350px !important; 
        padding-top: 60px !important; 
        padding-bottom: 20px !important; 
      }
      .hero-slider-one__title { 
        font-size: 26px !important; 
      }
      .hero-slider-one__sub-title { 
        font-size: 14px !important; 
      }
      .about-one.section-space-top,
      .about-one.mt-5,
      .section-space-top {
        margin-top: 0 !important;
        padding-top: 0 !important;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: paginationStyles }} />
      <style dangerouslySetInnerHTML={{ __html: sliderBgStyles }} />
      <style dangerouslySetInnerHTML={{ __html: sliderLayoutStyles }} />

      <section className="hero-slider-one hero-main-slider" id="home">
        <Swiper
          modules={[Autoplay, Pagination, EffectFade]}
          loop={true}
          effect="fade"
          autoplay={{ delay: 7000, disableOnInteraction: false }}
          speed={1000}
          pagination={{ clickable: true, dynamicBullets: false }}
          className="hero-slider-one__carousel"
        >
          <SwiperSlide>
            <div className="hero-slider-one__item">
              <div className="hero-slider-one__bg bg-slide-1"></div>
              <div className="container">
                <div className="row">
                  <div className="col-xxl-12 col-xl-10 col-lg-10">
                    <div className="hero-slider-one__content">
                      <h5 className="hero-slider-one__sub-title">{t('slider_subtitle')}</h5>
                      <h2 className="hero-slider-one__title">
                        {t('slider_title')} <br /> {t('slider_title_second')}
                        <span className="hero-slider-one__title__overlay-group">
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                        </span>
                      </h2>
                      <div className="hero-slider-one__btn">
                        <Link to="/about" className="boskery-btn">
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__text">{t('know_about_us')}</span>
                          <i className="icon-meat-3"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
          
          <SwiperSlide>
            <div className="hero-slider-one__item">
              <div className="hero-slider-one__bg bg-slide-2"></div>
              <div className="container-fluid px-0">
                <div className="row">
                  <div className="col-xxl-12 col-xl-10 col-lg-10">
                    <div className="hero-slider-one__content">
                      <h5 className="hero-slider-one__sub-title">{t('slider_subtitle')}</h5>
                      <h2 className="hero-slider-one__title">
                        {t('slider_title')} <br /> {t('slider_title_second')}
                        <span className="hero-slider-one__title__overlay-group">
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                        </span>
                      </h2>
                      <div className="hero-slider-one__btn">
                        <Link to="/about" className="boskery-btn">
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__text">{t('know_about_us')}</span>
                          <i className="icon-meat-3"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="hero-slider-one__item">
              <div className="hero-slider-one__bg bg-slide-3"></div>
              <div className="container">
                <div className="row">
                  <div className="col-xxl-12 col-xl-10 col-lg-10">
                    <div className="hero-slider-one__content">
                      <h5 className="hero-slider-one__sub-title">{t('slider_subtitle')}</h5>
                      <h2 className="hero-slider-one__title">
                        {t('slider_title')} <br /> {t('slider_title_second')}
                        <span className="hero-slider-one__title__overlay-group">
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                        </span>
                      </h2>
                      <div className="hero-slider-one__btn">
                        <Link to="/about" className="boskery-btn">
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__text">{t('know_about_us')}</span>
                          <i className="icon-meat-3"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="hero-slider-one__item">
              <div className="hero-slider-one__bg bg-slide-4"></div>
              <div className="container">
                <div className="row">
                  <div className="col-xxl-12 col-xl-10 col-lg-10">
                    <div className="hero-slider-one__content">
                      <h5 className="hero-slider-one__sub-title">{t('slider_subtitle')}</h5>
                      <h2 className="hero-slider-one__title">
                        {t('slider_title')} <br /> {t('slider_title_second')}
                        <span className="hero-slider-one__title__overlay-group">
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                        </span>
                      </h2>
                      <div className="hero-slider-one__btn">
                        <Link to="/about" className="boskery-btn">
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__text">{t('know_about_us')}</span>
                          <i className="icon-meat-3"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="hero-slider-one__item">
              <div className="hero-slider-one__bg bg-slide-5"></div>
              <div className="container">
                <div className="row">
                  <div className="col-xxl-12 col-xl-10 col-lg-10">
                    <div className="hero-slider-one__content">
                      <h5 className="hero-slider-one__sub-title">{t('slider_subtitle')}</h5>
                      <h2 className="hero-slider-one__title">
                        {t('slider_title')} <br /> {t('slider_title_second')}
                        <span className="hero-slider-one__title__overlay-group">
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                        </span>
                      </h2>
                      <div className="hero-slider-one__btn">
                        <Link to="/about" className="boskery-btn">
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__text">{t('know_about_us')}</span>
                          <i className="icon-meat-3"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="hero-slider-one__item">
              <div className="hero-slider-one__bg bg-slide-6"></div>
              <div className="container">
                <div className="row">
                  <div className="col-xxl-12 col-xl-10 col-lg-10">
                    <div className="hero-slider-one__content">
                      <h5 className="hero-slider-one__sub-title">{t('slider_subtitle')}</h5>
                      <h2 className="hero-slider-one__title">
                        {t('slider_title')} <br /> {t('slider_title_second')}
                        <span className="hero-slider-one__title__overlay-group">
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                          <span className="hero-slider-one__title__overlay"></span>
                        </span>
                      </h2>
                      <div className="hero-slider-one__btn">
                        <Link to="/about" className="boskery-btn">
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__hover"></span>
                          <span className="boskery-btn__text">{t('know_about_us')}</span>
                          <i className="icon-meat-3"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
          
        
        </Swiper>
      </section>
    </>
  );
};

export default Slider2;
